module.exports = "https://www.gc-qa.gnp.com.mx/1282e2e7115c9b9721bd52cc89be7b3b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/01-descargar-over.svg
// module id = 8034
// module chunks = 0